
import Vue from "vue";
import { mapState } from "vuex";
import { download } from "@/utils";
type OssMap = Record<string, string>;
interface PageState {
  activeAgentDemo: number;
  galleryIndex: Record<string, number>;
}
interface AgentDemo {
  key: string;
  label: string;
  src: string;
}

export default Vue.extend({
  data(): PageState {
    return {
      activeAgentDemo: 0,
      galleryIndex: { vision: 0, cloud: 0 }
    };
  },
  computed: {
    ...mapState("app", { isCN: "isCN", isMobile: "isMobile" }),
    ...mapState("assets", {     url: "url",oss: "oss" }),
    heroImage(): string {
      const assets = this.oss as OssMap;
      const device = this.isMobile ? "mobile" : "pc";
      const locale = this.isCN ? "cn" : "en";
      return assets[`cyberboard_r6_01_hero_${device}_${locale}`];
    },
    agentDemos(): AgentDemo[] {
      const assets = this.oss as OssMap;
      return [
        {
          key: "cyberboard_r6_08_agent_transcription",
          label: String(this.$t("cyberboardR6.demo01")),
          src: assets.cyberboard_r6_08_agent_transcription
        },
        {
          key: "cyberboard_r6_09_agent_control",
          label: String(this.$t("cyberboardR6.demo02")),
          src: assets.cyberboard_r6_09_agent_control
        },
        {
          key: "cyberboard_r6_10_agent_microphone",
          label: String(this.$t("cyberboardR6.demo03")),
          src: assets.cyberboard_r6_10_agent_microphone
        }
      ];
    },
    agentDemo(): AgentDemo {
      const state = this.$data as PageState;
      return (this.agentDemos as AgentDemo[])[state.activeAgentDemo];
    },
    colorGalleries() {
      const assets = this.oss as OssMap;
      return [
        {
          key: "vision",
          title: String(this.$t("cyberboardR6.visionTitle")),
          copy: String(this.$t("cyberboardR6.visionText")),
          slides: [
            {
              src: assets.cyberboard_r6_14_vision_01,
              alt: String(this.$t("cyberboardR6.imageAlt.vision01"))
            },
            {
              src: assets.cyberboard_r6_14_vision_02,
              alt: String(this.$t("cyberboardR6.imageAlt.vision02"))
            },
            {
              src: assets.cyberboard_r6_14_vision_03,
              alt: String(this.$t("cyberboardR6.imageAlt.vision03"))
            }
          ]
        },
        {
          key: "cloud",
          title: String(this.$t("cyberboardR6.cloudTitle")),
          copy: String(this.$t("cyberboardR6.cloudText")),
          slides: [
            {
              src: assets.cyberboard_r6_15_cloud_white_01,
              alt: String(this.$t("cyberboardR6.imageAlt.cloud01"))
            },
            {
              src: assets.cyberboard_r6_15_cloud_white_02,
              alt: String(this.$t("cyberboardR6.imageAlt.cloud02"))
            },
            {
              src: assets.cyberboard_r6_15_cloud_white_03,
              alt: String(this.$t("cyberboardR6.imageAlt.cloud03"))
            }
          ]
        }
      ];
    },
    specItems() {
      const assets = this.oss as OssMap;
      return [
        {
          key: "receiver",
          icon: assets.cyberboard_r6_16_spec_receiver,
          title: String(this.$t("cyberboardR6.spec01Title")),
          text: String(this.$t("cyberboardR6.spec01Text"))
        },
        {
          key: "dual-mode",
          icon: assets.cyberboard_r6_16_spec_dual_mode,
          title: String(this.$t("cyberboardR6.spec02Title")),
          text: String(this.$t("cyberboardR6.spec02Text"))
        },
        {
          key: "system",
          icon: assets.cyberboard_r6_16_spec_system_auto,
          title: String(this.$t("cyberboardR6.spec03Title")),
          text: String(this.$t("cyberboardR6.spec03Text"))
        },
        {
          key: "battery",
          icon: assets.cyberboard_r6_16_spec_battery,
          title: String(this.$t("cyberboardR6.specBatteryTitle")),
          text: ""
        },
        {
          key: "wireless-charge",
          icon: assets.cyberboard_r6_16_spec_wireless_charge,
          title: String(this.$t("cyberboardR6.spec04Title")),
          text: String(this.$t("cyberboardR6.spec04Text"))
        }
      ];
    }
  },
  methods: {
    selectAgentDemo(index: number) {
      const state = this.$data as PageState;
      const video = this.$el.querySelector(
        ".agent-demo video"
      ) as HTMLVideoElement;
      if (video) video.pause();
      state.activeAgentDemo = index;
    },
    moveGallery(event: MouseEvent, direction: number) {
      const button = event.currentTarget as HTMLElement;
      const track = button.parentElement?.querySelector(
        ".gallery-track"
      ) as HTMLElement;
      if (!track) return;
      const current = Math.round(
        track.scrollLeft / Math.max(track.clientWidth, 1)
      );
      const next = (current + direction + 3) % 3;
      track.scrollTo({ left: next * track.clientWidth, behavior: "smooth" });
    },
    onGalleryScroll(event: Event, key: string) {
      const track = event.currentTarget as HTMLElement;
      const index = Math.min(
        2,
        Math.round(track.scrollLeft / Math.max(track.clientWidth, 1))
      );
      this.$set((this.$data as PageState).galleryIndex, key, index);
    },
    pauseOtherVideos(event: Event) {
      const current = event.target as HTMLVideoElement;
      this.$el.querySelectorAll("video").forEach(video => {
        if (video !== current) video.pause();
      });
    },
    onVerify() {
      window.open(
        this.$paths.verify + "cyberboard/",
        "_blank",
        "noopener,noreferrer"
      );
    },
    onDownload() {
      download(this.oss.pdf_cyberboard_r6);
    },
  }
});
